import { store } from '@/state/store.js';

/**
 * Returns the api path with the current team
 * @returns {String}
 */
export function teamPath() {
  return `/api/${store.getters['me/teamPath']}`;
}

/**
 * Returns the correct api path without the team id
 * @returns {String}
 */
export function teamRoot() {
  return `/api/${store.getters['me/teamRoot']}`;
}

/**
 * Returns the org team api path
 * @returns {String}
 */
export function orgPath() {
  return `/api/orgs/${store.getters['me/teamId']}`;
}

/**
 * Returns the dev team api path
 * @returns {String}
 */
export function devPath() {
  return `/api/developers/${store.getters['me/teamId']}`;
}
